export enum AcompanhamentoAtaMutationTypes {
  SET_TRABALHO = 'SET_TRABALHO',
  SET_ANDAMENTO = 'SET_ANDAMENTO',
  SET_ERRO = 'SET_ERRO',
  MOSTRAR = 'MOSTRAR',
  OCULTAR = 'OCULTAR',
  ALTERNAR_RECOLHIDA = 'ALTERNAR_RECOLHIDA',
  LIMPAR = 'LIMPAR',
}
